import { Container, Row, Col } from "react-bootstrap";
import { QuickStepData } from "./pamo-quick-data";
import { HoverCard } from "../../../common/hover-cards/HoverCards";
import "./pamo-quick-step.scss";
import { ArrowPointer } from "../../../common/navigating-arrow/ArrowPointer";

export const PamoQuickStep = () => {
  return (
    <Container fluid className="tutorial-section ">
      <div className="tutorial-parent-header text-center">
        <p className="quick-steps-header fw-bold text-center my-5">
          Craft Your Irresistible Offer: Pamo's Quick Steps!
        </p>
      </div>
      <div className="tut-card-container d-flex jusfify-content-center">
      <div className="tutorial-card-container  d-md-flex d-lg-flex  flex-nowrap overflow-auto  jusfify-content-center align-items-stretch ">
        {QuickStepData.map((data, key) => (
          <div key={key}  className="tutorial-card-col mx-3 my-5">
            <div className="equal-height-card-wrapper">
              <HoverCard data={data} />
            </div>
          </div>
        ))}
      </div>
      </div>
      <ArrowPointer/>
    </Container>
  );
};
